import { useRef } from 'react';

export function useClickOutside() {
  const wrapperRef = useRef<HTMLElement>(null);
  let safeSpace: Array<HTMLElement> = Array.from(document.querySelectorAll('div')).filter(
    (element) => element.id.includes('wrs') || element.className.includes('wrs')
  );
  const handleClickOutside = (event: MouseEvent, callback?: Function, references?: any[]) => {
    references?.forEach((reference) => {
      if (Array.isArray(reference)) {
        Array.from(reference).map((node) => safeSpace.push(node));
      } else safeSpace.push(reference);
      const isClickingOutside = () => {
        return !safeSpace.some((space) => {
          const descendants = space ? Array.from(space.querySelectorAll('*')) : [];
          return descendants.includes(event.target as HTMLElement);
        });
      };
      if (isClickingOutside()) {
        return callback && callback();
      }
    });
  };

  return { wrapperRef, handleClickOutside };
}
